/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/_Layout'
import { Route as CatchAllRouteImport } from './routes/CatchAll'
import { Route as HomePageRouteImport } from './routes/HomePage'
import { Route as sessionSessionLayoutRouteImport } from './routes/session/SessionLayout'
import { Route as siteCheckInSiteCheckInLayoutRouteImport } from './routes/site-check-in/SiteCheckInLayout'
import { Route as sessionPaymentCallbackPageRouteImport } from './routes/session/PaymentCallbackPage'
import { Route as sessionPaymentPageRouteImport } from './routes/session/PaymentPage'
import { Route as siteCheckInSmsSentPageRouteImport } from './routes/site-check-in/SmsSentPage'
import { Route as siteCheckInRegistrationPageRouteImport } from './routes/site-check-in/RegistrationPage'
import { Route as sessionSessionPageRouteImport } from './routes/session/SessionPage'
import { Route as siteCheckInSiteCheckInPageRouteImport } from './routes/site-check-in/SiteCheckInPage'

const CatchAllRoute = CatchAllRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const HomePageRoute = HomePageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const sessionSessionLayoutRoute = sessionSessionLayoutRouteImport.update({
  id: '/s/$sessionUuid',
  path: '/s/$sessionUuid',
  getParentRoute: () => rootRouteImport,
} as any)
const siteCheckInSiteCheckInLayoutRoute =
  siteCheckInSiteCheckInLayoutRouteImport.update({
    id: '/$companyLocationCode/$siteCode',
    path: '/$companyLocationCode/$siteCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const sessionPaymentCallbackPageRoute =
  sessionPaymentCallbackPageRouteImport.update({
    id: '/payment-callback',
    path: '/payment-callback',
    getParentRoute: () => sessionSessionLayoutRoute,
  } as any)
const sessionPaymentPageRoute = sessionPaymentPageRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => sessionSessionLayoutRoute,
} as any)
const siteCheckInSmsSentPageRoute = siteCheckInSmsSentPageRouteImport.update({
  id: '/sms-sent',
  path: '/sms-sent',
  getParentRoute: () => siteCheckInSiteCheckInLayoutRoute,
} as any)
const siteCheckInRegistrationPageRoute =
  siteCheckInRegistrationPageRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => siteCheckInSiteCheckInLayoutRoute,
  } as any)
const sessionSessionPageRoute = sessionSessionPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => sessionSessionLayoutRoute,
} as any)
const siteCheckInSiteCheckInPageRoute =
  siteCheckInSiteCheckInPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => siteCheckInSiteCheckInLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof HomePageRoute
  '/$': typeof CatchAllRoute
  '/$companyLocationCode/$siteCode': typeof siteCheckInSiteCheckInLayoutRouteWithChildren
  '/s/$sessionUuid': typeof sessionSessionLayoutRouteWithChildren
  '/$companyLocationCode/$siteCode/': typeof siteCheckInSiteCheckInPageRoute
  '/s/$sessionUuid/': typeof sessionSessionPageRoute
  '/$companyLocationCode/$siteCode/register': typeof siteCheckInRegistrationPageRoute
  '/$companyLocationCode/$siteCode/sms-sent': typeof siteCheckInSmsSentPageRoute
  '/s/$sessionUuid/payment': typeof sessionPaymentPageRoute
  '/s/$sessionUuid/payment-callback': typeof sessionPaymentCallbackPageRoute
}
export interface FileRoutesByTo {
  '/': typeof HomePageRoute
  '/$': typeof CatchAllRoute
  '/$companyLocationCode/$siteCode': typeof siteCheckInSiteCheckInPageRoute
  '/s/$sessionUuid': typeof sessionSessionPageRoute
  '/$companyLocationCode/$siteCode/register': typeof siteCheckInRegistrationPageRoute
  '/$companyLocationCode/$siteCode/sms-sent': typeof siteCheckInSmsSentPageRoute
  '/s/$sessionUuid/payment': typeof sessionPaymentPageRoute
  '/s/$sessionUuid/payment-callback': typeof sessionPaymentCallbackPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof HomePageRoute
  '/$': typeof CatchAllRoute
  '/$companyLocationCode/$siteCode': typeof siteCheckInSiteCheckInLayoutRouteWithChildren
  '/s/$sessionUuid': typeof sessionSessionLayoutRouteWithChildren
  '/$companyLocationCode/$siteCode/': typeof siteCheckInSiteCheckInPageRoute
  '/s/$sessionUuid/': typeof sessionSessionPageRoute
  '/$companyLocationCode/$siteCode/register': typeof siteCheckInRegistrationPageRoute
  '/$companyLocationCode/$siteCode/sms-sent': typeof siteCheckInSmsSentPageRoute
  '/s/$sessionUuid/payment': typeof sessionPaymentPageRoute
  '/s/$sessionUuid/payment-callback': typeof sessionPaymentCallbackPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/$companyLocationCode/$siteCode'
    | '/s/$sessionUuid'
    | '/$companyLocationCode/$siteCode/'
    | '/s/$sessionUuid/'
    | '/$companyLocationCode/$siteCode/register'
    | '/$companyLocationCode/$siteCode/sms-sent'
    | '/s/$sessionUuid/payment'
    | '/s/$sessionUuid/payment-callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/$companyLocationCode/$siteCode'
    | '/s/$sessionUuid'
    | '/$companyLocationCode/$siteCode/register'
    | '/$companyLocationCode/$siteCode/sms-sent'
    | '/s/$sessionUuid/payment'
    | '/s/$sessionUuid/payment-callback'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/$companyLocationCode/$siteCode'
    | '/s/$sessionUuid'
    | '/$companyLocationCode/$siteCode/'
    | '/s/$sessionUuid/'
    | '/$companyLocationCode/$siteCode/register'
    | '/$companyLocationCode/$siteCode/sms-sent'
    | '/s/$sessionUuid/payment'
    | '/s/$sessionUuid/payment-callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  HomePageRoute: typeof HomePageRoute
  CatchAllRoute: typeof CatchAllRoute
  siteCheckInSiteCheckInLayoutRoute: typeof siteCheckInSiteCheckInLayoutRouteWithChildren
  sessionSessionLayoutRoute: typeof sessionSessionLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof CatchAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomePageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$sessionUuid': {
      id: '/s/$sessionUuid'
      path: '/s/$sessionUuid'
      fullPath: '/s/$sessionUuid'
      preLoaderRoute: typeof sessionSessionLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$companyLocationCode/$siteCode': {
      id: '/$companyLocationCode/$siteCode'
      path: '/$companyLocationCode/$siteCode'
      fullPath: '/$companyLocationCode/$siteCode'
      preLoaderRoute: typeof siteCheckInSiteCheckInLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$sessionUuid/payment-callback': {
      id: '/s/$sessionUuid/payment-callback'
      path: '/payment-callback'
      fullPath: '/s/$sessionUuid/payment-callback'
      preLoaderRoute: typeof sessionPaymentCallbackPageRouteImport
      parentRoute: typeof sessionSessionLayoutRoute
    }
    '/s/$sessionUuid/payment': {
      id: '/s/$sessionUuid/payment'
      path: '/payment'
      fullPath: '/s/$sessionUuid/payment'
      preLoaderRoute: typeof sessionPaymentPageRouteImport
      parentRoute: typeof sessionSessionLayoutRoute
    }
    '/$companyLocationCode/$siteCode/sms-sent': {
      id: '/$companyLocationCode/$siteCode/sms-sent'
      path: '/sms-sent'
      fullPath: '/$companyLocationCode/$siteCode/sms-sent'
      preLoaderRoute: typeof siteCheckInSmsSentPageRouteImport
      parentRoute: typeof siteCheckInSiteCheckInLayoutRoute
    }
    '/$companyLocationCode/$siteCode/register': {
      id: '/$companyLocationCode/$siteCode/register'
      path: '/register'
      fullPath: '/$companyLocationCode/$siteCode/register'
      preLoaderRoute: typeof siteCheckInRegistrationPageRouteImport
      parentRoute: typeof siteCheckInSiteCheckInLayoutRoute
    }
    '/s/$sessionUuid/': {
      id: '/s/$sessionUuid/'
      path: '/'
      fullPath: '/s/$sessionUuid/'
      preLoaderRoute: typeof sessionSessionPageRouteImport
      parentRoute: typeof sessionSessionLayoutRoute
    }
    '/$companyLocationCode/$siteCode/': {
      id: '/$companyLocationCode/$siteCode/'
      path: '/'
      fullPath: '/$companyLocationCode/$siteCode/'
      preLoaderRoute: typeof siteCheckInSiteCheckInPageRouteImport
      parentRoute: typeof siteCheckInSiteCheckInLayoutRoute
    }
  }
}

interface siteCheckInSiteCheckInLayoutRouteChildren {
  siteCheckInSiteCheckInPageRoute: typeof siteCheckInSiteCheckInPageRoute
  siteCheckInRegistrationPageRoute: typeof siteCheckInRegistrationPageRoute
  siteCheckInSmsSentPageRoute: typeof siteCheckInSmsSentPageRoute
}

const siteCheckInSiteCheckInLayoutRouteChildren: siteCheckInSiteCheckInLayoutRouteChildren =
  {
    siteCheckInSiteCheckInPageRoute: siteCheckInSiteCheckInPageRoute,
    siteCheckInRegistrationPageRoute: siteCheckInRegistrationPageRoute,
    siteCheckInSmsSentPageRoute: siteCheckInSmsSentPageRoute,
  }

const siteCheckInSiteCheckInLayoutRouteWithChildren =
  siteCheckInSiteCheckInLayoutRoute._addFileChildren(
    siteCheckInSiteCheckInLayoutRouteChildren,
  )

interface sessionSessionLayoutRouteChildren {
  sessionSessionPageRoute: typeof sessionSessionPageRoute
  sessionPaymentPageRoute: typeof sessionPaymentPageRoute
  sessionPaymentCallbackPageRoute: typeof sessionPaymentCallbackPageRoute
}

const sessionSessionLayoutRouteChildren: sessionSessionLayoutRouteChildren = {
  sessionSessionPageRoute: sessionSessionPageRoute,
  sessionPaymentPageRoute: sessionPaymentPageRoute,
  sessionPaymentCallbackPageRoute: sessionPaymentCallbackPageRoute,
}

const sessionSessionLayoutRouteWithChildren =
  sessionSessionLayoutRoute._addFileChildren(sessionSessionLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  HomePageRoute: HomePageRoute,
  CatchAllRoute: CatchAllRoute,
  siteCheckInSiteCheckInLayoutRoute:
    siteCheckInSiteCheckInLayoutRouteWithChildren,
  sessionSessionLayoutRoute: sessionSessionLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
